import React from 'react';
import styles from './Header.module.scss';
import { useBrandingContext } from 'app-context/BrandingsContext';
import { useNavigate } from 'react-router-dom';
import SvgWithBranding from 'component/hoc/branding/withBrandingColor.hoc';
import { useResponsive } from 'assets/styles/breakpoints/breakpoint';
import TabletSidebar from '../sidebar/tablets/TabletSidebar';
import defaultLogo from './default-mobile-logo.svg';
import { format } from 'date-fns';
const leftArrow = '/src/svg/arrows/chevron-left.svg';

//this needs fixing responsive
const Header = ({
  title,
  createdAt,
  children,
  isBack = false,
  onBackClick = null,
  subTitle,
  containerClassname,
  isSub = false,
  titleClassName,
  tag,
}) => {
  const { isTablet } = useResponsive();
  const navigate = useNavigate();
  const { brandingData } = useBrandingContext();
  const {
    sideBar_PrimaryColor,
    mobileLogo,
    mobileLogoContentType,
    page_TextColor,
    page_FontStyle,
  } = brandingData;
  const handleBack = () => {
    if (onBackClick) {
      onBackClick();
    } else {
      navigate(-1);
    }
  };
  return (
    <div
      className={`${styles['header-container']} ${containerClassname}`}
      style={{ color: page_TextColor, fontStyle: page_FontStyle }}
    >
      <div className={styles['title-container']}>
        <div className={styles['header-subcontainer']}>
          {isBack && isSub ? (
            <button className={styles['arrow']} onClick={handleBack}>
              <img src={leftArrow} alt='' />
            </button>
          ) : isBack ? (
            <button className={styles['arrow']} onClick={handleBack}>
              <img src={leftArrow} alt='' />
            </button>
          ) : null}
          <div className={styles['subcontainer']}>
            {isTablet && !isBack ? <TabletSidebar /> : <></>}
            <div className={styles['title-container']}>
              <div className={styles['title-wrapper']}>
                <p
                  style={{ color: sideBar_PrimaryColor }}
                  className={`${styles['title']} ${titleClassName}`}
                >
                  {title}
                </p>
                {tag && <div className={styles['tag']}>{tag}</div>}
              </div>

              {subTitle && isTablet ? (
                <p
                  style={{ color: sideBar_PrimaryColor }}
                  className={styles['subtitle']}
                >
                  {subTitle}
                </p>
              ) : null}
              {createdAt ? (
                <p
                  style={{ color: sideBar_PrimaryColor }}
                  className={styles['create-at']}
                >
                  Created: {format(new Date(createdAt), 'dd / MM / yyyy')}
                </p>
              ) : null}
            </div>

            <div>
              {mobileLogo ? (
                <img
                  src={`data:${mobileLogoContentType};base64,${mobileLogo}`}
                  height={30}
                  className={styles['mobile-logo']}
                />
              ) : (
                <img
                  src={defaultLogo}
                  height={30}
                  className={styles['mobile-logo']}
                />
              )}
            </div>
          </div>
          {subTitle && !isTablet ? (
            <p
              style={{ color: sideBar_PrimaryColor }}
              className={styles['subtitle']}
            >
              {subTitle}
            </p>
          ) : null}
        </div>
      </div>

      {children ? (
        <div className={styles['header-content']}>{children}</div>
      ) : null}
    </div>
  );
};

export default Header;
